import { Upload as AntUpload } from 'antd';
import { FC, ReactChildren, ReactNode } from 'react';
import { UploadProps, DraggerProps } from 'antd/lib/upload';

type Props = {
  isDragger?: boolean;
} & UploadProps &
  DraggerProps;

export const Upload: FC<Props> = (props) => {
  if (props.isDragger) {
    return <AntUpload.Dragger {...props} />;
  }

  return <AntUpload {...props} />;
};

export default Upload;
